/**
 * Constructor
 * @type {{Steps: {set: Window.Constructor.Steps.set}, Gift: {change: Window.Constructor.Gift.change, run: Window.Constructor.Gift.run}, Action: {top: Window.Constructor.Action.top, reset: Window.Constructor.Action.reset}, Toys: {add: Window.Constructor.Toys.add, calculation: Window.Constructor.Toys.calculation, change: Window.Constructor.Toys.change, remove: Window.Constructor.Toys.remove, push: Window.Constructor.Toys.push}, toys: *[], pricePackage: number, selector: (*|jQuery|HTMLElement), sweets: *[], Package: {filter: Window.Constructor.Package.filter, sorted: (function(): [string,undefined]), filtered: (function(): [*[],*[]]), load: Window.Constructor.Package.load, reset: Window.Constructor.Package.reset, sort: Window.Constructor.Package.sort, choice: Window.Constructor.Package.choice}, Sweets: {calculation: Window.Constructor.Sweets.calculation, filtered: (function(): [*[],*[]]), load: Window.Constructor.Sweets.load, get: Window.Constructor.Sweets.get, scatter: Window.Constructor.Sweets.scatter, reset: Window.Constructor.Sweets.reset, filters: Window.Constructor.Sweets.filters, choice: Window.Constructor.Sweets.choice}}}
 */
window.Constructor = {
	selector: $('#constructor'),
	sweets: [],
	toys: [],
	pricePackage: 0,

	Action: {
		top: function (offset) {
			$([document.documentElement, document.body]).delay(100).animate({
				scrollTop: offset - 64
			}, 1000);
		},

		reset: function () {
			Constructor.selector.find('.sweet .active').find('input').val(0);
			Constructor.selector.find('.sweet .active').removeClass('active');
			Constructor.selector.find('.sweet .minus').addClass('disabled');
			Constructor.selector.attr('data-content', 'shortage')
			Constructor.sweets = [];
			Constructor.Sweets.calculation('sweet');
		},
	},

	Steps: {
		set: function (step) {
			let _this = Constructor,
				$selector = _this.selector,
				curStep = $selector.data('step'),
				$steps = $selector.find('#constructor-steps');

			$steps.find('.active').removeClass('active');
			$steps.find('[data-step="' + step + '"]').addClass('active');

			$selector.attr('data-step', step)

			if ((step - 1) !== 0 && curStep !== step) {
				$steps.find('[data-step="' + (step - 1) + '"]').addClass('passed');
			}
		}
	},

	Package: {
		sort: function ($self) {
			let $item = $self.closest('[data-sort]'),
				key = $item.data('sort'),
				name = 'sort-' + key,
				val = $self.data('sort-type');

			const $listSort = $('#list-sort');

			if ($listSort.length) {
				let $sorts = $listSort.find('[data-sort]');
				$sorts.each(function () {
					let $list = $(this);

					$list.removeClass('active');
					$list.find('.selected').removeClass('selected');
					$list.find('a[data-bs-toggle]').text('выбрать');
				});

				let $list = $listSort.find('[data-sort="' + key + '"]');
				if ($list) {
					$list.addClass('active');

					let $title_val = $list.find('[data-sort-type="' + val + '"]'),
						title = '';

					if ($title_val.length) {
						title = $title_val.text();
						$title_val.addClass('selected');
					}

					let $dropdown = $list.find('a[data-bs-toggle]');
					$dropdown.text(title);

					if ($dropdown.length) {
						const dropdown = new bootstrap.Dropdown($dropdown, {})
						dropdown.hide();
					}

					let filters = this.filtered(),
						params = {
						_token: App.csrf,
						[name]: val,
						materials: filters[1],
						weights: filters[0]
					};

					this.load(params)
				}
			}
		},

		filter: function ($self) {
			$self.addClass('active').addClass('dropFiltersPackage').removeClass('getFiltersPackage');

			let sorted = this.sorted(),
				filters = this.filtered(),
				params = {
					_token: App.csrf,
					[sorted[0]]: sorted[1],
					materials: filters[1],
					weights: filters[0]
				};

			this.load(params);
		},

		filtered: function () {
			let $materials = $('.m-package'), materials = [];
			$materials.each(function () {
				if ($(this).hasClass('active')) {
					materials.push($(this).data('id'))
				}
			});

			let $weights = $('.w-package'), weights = [];
			$weights.each(function () {
				if ($(this).hasClass('active')) {
					weights.push($(this).data('id'))
				}
			});

			return [weights, materials];
		},

		sorted: function() {
			let name, val;

			const $listSort = $('#list-sort');
			let $list = $listSort.find('[data-sort].active');

			name = 'sort-' + $list.data('sort');
			val = $list.find('.selected').data('sort-type');

			return [name, val];
		},

		reset: function ($self) {
			let sorted = this.sorted();

			$self.removeClass('active').removeClass('dropFiltersPackage').addClass('getFiltersPackage');

			let filters = this.filtered(),
				params = {
				_token: App.csrf,
				[sorted[0]]: sorted[1],
				materials: filters[1],
				weights: filters[0]
			};

			this.load(params);
		},

		load: function (params) {
			$.ajax({
				type: "POST",
				url: "/constructor/getFiltersPackage",
				data: params,
				beforeSend: function () {
					//$('.loaderPackage').fadeIn();
				},
				success: function (data) {
					//$('.loaderPackage').fadeOut();

					let $section = Constructor.selector,
						$body = $section.find('.constructor-package-wrapper');

					if (data.error === false) {
						$body.html(data.items);
					}
				}
			});
		},

		choice: function ($self) {
			let _this = Constructor,
				$selector = _this.selector,
				$item = $self.closest('.vg-prd'),
				id = $item.data('id'),
				weight = $item.data('weight'),
				img = $item.find('img').attr('src'),
				offset = 0;

			_this.pricePackage = parseInt($item.data('price'));

			$selector.find('.package-image').attr('data-id', id).find('img').attr('src', img);
			$selector.find('.package-price .package-current-price').text(_this.pricePackage);
			$selector.find('#constructor-panel').find('.package-weight').text(weight);

			_this.Sweets.get(offset, false, 0);
		}
	},

	Sweets: {
		get: function (offset, more, filter) {
			let _this = Constructor,
				data = {
				offset: offset,
				materials: filter[1],
				vendors: filter[0],
				_token: App.csrf
			};

			$.post('/constructor/getItems', data, function (data) {
				let $section = _this.selector,
					$body = $section.find('.constructor-package-wrapper');

				if (data.error === false) {
					if (more) {
						if (data.cnt > 0) {
							$body.find('.constructor-sweets').fadeIn().append(data.items)
						} else {
							$body.find('.constructor-sweets').fadeIn().append('<div style="margin-top: 50px; text-align: center"><h3>Конфет больше нет</h3></div>');
							$('.sweet-load-more').addClass('null');
						}
					} else {
						$body.html(data.items);

						$section.find('.filters-package.material').slideUp();
						$section.find('.filters-package.weight').slideUp();
						$section.find('#constructor-sort').slideUp();

						$section.find('.filters-package.fitems').slideDown('slow');
						$section.find('.filters-package.package-cover').slideDown('slow');
						$section.find('.filters-package.vendors').slideDown('slow');

						_this.Steps.set(2);
						_this.Action.top($section.offset().top);
					}

					_this.Sweets.scatter();
				}
			});
		},

		choice: function ($self, action = '') {
			let $parent = $self.parents('.sweet-cnt'),
				$input = $parent.find('input'),
				$sweet = $self.closest('.sweet'),
				cnt = parseInt($input.val()),
				id = $sweet.data('id'),
				weight = $sweet.data('weight'),
				price = $sweet.data('price'),
				sweets = Constructor.sweets,
				type = 'minus',
				new_sweet = true,
				min = parseInt($input.attr('min')),
				max = parseInt($input.attr('max'));

			if (!action) {
				if ($self.hasClass('plus')) {
					type = 'plus';
				}

				if (type === 'minus') {
					if (cnt > min) {
						cnt--;
					} else {
						cnt = min
					}
				}

				if (type === 'plus') {
					if (cnt < max) {
						cnt++;
					} else {
						cnt = max
					}
				}
			}

			if (cnt === min) {
				$self.addClass('disabled');
			} else {
				$self.closest('.sweet-cnt').find('.minus').removeClass('disabled');
			}

			if (cnt >= max) {
				$self.addClass('disabled');
			} else {
				$self.closest('.sweet-cnt').find('.plus').removeClass('disabled');
			}

			if (cnt > 0) {
				$sweet.find('.sweet-wrapper').addClass('active');
			} else {
				$sweet.find('.sweet-wrapper').removeClass('active');
			}

			$input.val(cnt);

			let n_sweet = {
				id: id,
				cnt: cnt,
				weight: weight,
				price: price
			};

			if (sweets.length) {
				$.each(sweets, function (i, sweet) {
					if (sweet['id'] === id) {
						sweet['cnt'] = cnt;
						new_sweet = false;
					}
				});
			}

			if (new_sweet) {
				Constructor.sweets.push(n_sweet);
			}

			this.calculation('sweet');
		},

		scatter: function () {
			let _this = Constructor;

			if (_this.sweets.length) {
				$.each(_this.sweets, function (i, sweet) {
					if (sweet['cnt'] > 0) {
						let $sweet = $('.sweet[data-id=' + sweet['id'] + ']').find('.sweet-wrapper');
						$sweet.addClass('active');

						$sweet.find('[name=cnt]').val(sweet['cnt']);
					}
				});

				_this.Sweets.calculation('sweet');
			}
		},

		calculation: function () {
			let _this = Constructor;

			let $construct_panel = $('#constructor-panel'),
				$progress = $construct_panel.find('.progress'),
				current_package = parseInt($construct_panel.find('.package-weight').text()),
				packageWeight = 0,
				packagePrice = 0,
				package_min_weight = current_package - 50,
				package_max_weight = current_package + 50,
				$btn = $construct_panel.find('.btn-main-ctrl'),
				$package_info = $construct_panel.find('.package-info');

			$.each(_this.sweets, function (i, sweet) {
				if (sweet['cnt'] > 0) {
					packageWeight += (sweet['weight'] * sweet['cnt']);
					packagePrice += (sweet['price'] * sweet['cnt']);
				}
			});

			packagePrice = packagePrice + _this.pricePackage;
			packagePrice = Math.round((packagePrice) * 100) / 100;

			$construct_panel.find('.package-current-weight').text(packageWeight);
			$construct_panel.find('.package-current-price').text(packagePrice);

			let $prBar = $progress.find('.progress-bar'),
				$prInfo = $progress.find('.progress-info'),
				percent = Math.round(packageWeight * 100 / package_max_weight),
				pr_bar_width = percent + '%',
				pr_info_left = 'calc(' + percent + '% - 39px)';

			if (percent <= 100) {
				$prBar.css('width', pr_bar_width);
				$prInfo.css('left', pr_info_left);
			}

			if (percent > 0) {
				$construct_panel.find('.btn-reload').removeClass('disabled');
			} else {
				$construct_panel.find('.btn-reload').addClass('disabled');
			}

			if (packageWeight <= package_max_weight && packageWeight >= package_min_weight) {
				$construct_panel.attr('data-content', 'normal');
			} else if (packageWeight > package_max_weight) {
				$construct_panel.attr('data-content', 'overkill');
			} else if (packageWeight < package_min_weight) {
				$construct_panel.attr('data-content', 'shortage');
			} else {
				$construct_panel.attr('data-content', 'shortage');
			}

			let contentGift = $construct_panel.attr('data-content');

			if (contentGift === 'normal') {
				$progress.attr('data-type', 'success');
				$prBar.text('Идеальный вес!');
				$construct_panel.find('.btn-order').removeClass('disabled');
			} else if (contentGift === 'overkill') {
				$progress.attr('data-type', 'danger');
				$prBar.text('Перебор веса!');
				$construct_panel.find('.btn-order').addClass('disabled');
			} else if (contentGift === 'shortage') {
				$progress.attr('data-type', 'danger');
				$prBar.text('Недобор веса!');
				$construct_panel.find('.btn-order').addClass('disabled');
			}
		},

		filtered: function () {
			let $materials = $('.f-package'), materials = [];
			$materials.each(function () {
				if ($(this).hasClass('active')) {
					materials.push($(this).data('id'))
				}
			});

			let $vendors = $('.v-package'), vendors = [];
			$vendors.each(function () {
				if ($(this).hasClass('active')) {
					vendors.push($(this).data('id'))
				}
			});

			return [vendors, materials];
		},

		filters: function ($self) {
			$self.addClass('active').addClass('dropFilters').removeClass('getFilters');
			let filters = Constructor.Sweets.filtered();
			Constructor.Sweets.get(0, false, filters);
		},

		reset: function ($self) {
			$self.removeClass('active').removeClass('dropFilters').addClass('getFilters');
			let filters = Constructor.Sweets.filtered();
			Constructor.Sweets.get(0, false, filters);
		},

		load: function (offset) {
			let _this = Constructor.Sweets,
				filters = _this.filtered();

			_this.get(offset, true, filters);
		}
	},

	Toys: {
		add: function ($self) {
			let _this = Constructor,
				$toy = $self.closest('.toy'),
				id = $toy.data('id'),
				title = $toy.find('.title').text(),
				img = $toy.find('img').attr('src');

			$toy.addClass('active');

			let $clone = Constructor.selector.find('.cloneItemConstruct'),
				$items = Constructor.selector.find('.appendItemsConstruct');

			if (!$items.find('[data-id=t-' + id + ']').length) {
				$clone.clone()
					.prependTo($items)
					.addClass('component toy')
					.removeClass('cloneItemConstruct')
					.removeAttr('style')
					.attr('data-id', 't-' + id);

				let $cloned_item = $items.find('[data-id=t-' + id + ']');
				$cloned_item.find('img').attr('src', img);
				$cloned_item.find('.inner span').text(title);
				$cloned_item.find('.cnt-toys').text(1);
			}

			_this.Toys.push($toy, 1, true);
		},

		change: function ($self, action) {
			let _this = Constructor,
				$toy = $self.closest('.toy'),
				$input = $toy.find('input'),
				cnt = parseInt($input.val()),
				min = parseInt($input.attr('min')),
				max = parseInt($input.attr('max')),
				type = $self.attr('data-type'),
				id = $toy.data('id');

			if (!action) {
				if (type === 'minus') {
					if (cnt > min) {
						cnt--;
					} else {
						cnt = min
					}
				}

				if (type === 'plus') {
					if (cnt < max) {
						cnt++;
					} else {
						cnt = max
					}
				}

				if (type === 'trash') {
					_this.Toys.remove($toy);
				}
			}

			if (cnt === min) {
				$self.find('.fa').removeClass('fa-minus').addClass('fa-trash');
				$self.attr('data-type', 'trash');
			} else {
				$self.closest('.counter').find('[data-type="trash"]').find('.fa').removeClass('fa-trash').addClass('fa-minus');
				$self.closest('.counter').find('[data-type="trash"]').attr('data-type', 'minus');
				$self.closest('.counter').find('[data-type="minus"]').attr('disabled', false);
			}

			if (cnt >= max) {
				$self.attr('disabled', true);
			} else {
				$self.closest('.counter').find('[data-type="plus"]').attr('disabled', false);
			}

			$input.val(cnt);

			_this.Toys.push($toy, cnt, false);
		},

		remove: function ($toy) {
			$toy.removeClass('active');
			Constructor.selector.find('.appendItemsConstruct').find('[data-id=t-' + $toy.data('id') + ']').remove();

			let id = parseInt($toy.attr('data-id'));
			Constructor.toys.forEach(function (item, index, object) {
				if (item.id === id) {
					object.splice(index, 1);
				}
			});

			this.calculation();
		},

		push: function ($toy, cnt, newToy) {
			let _this = Constructor,
				toys_arr = [],
				id = $toy.data('id'),
				price = $toy.data('price');

			if (newToy) {
				let nToy = {
					id: id,
					cnt: cnt,
					price: price,
				};
				_this.toys.push(nToy);
			} else {
				$.each(_this.toys, function (i, toy) {
					if (toy['id'] === id) {
						toy['cnt'] = cnt;
					}
				});

				$.each(_this.toys, function (i, toy) {
					if (toy['cnt'] > 0) {
						let nToy = {
							id: toy['id'],
							cnt: toy['cnt'],
							price: toy['price'],
						};

						toys_arr.push(nToy);
					}
				});

				_this.toys = toys_arr;
			}

			_this.Toys.calculation();
		},

		calculation: function () {
			let _this = Constructor,
				$total = _this.selector.find('.gift-payment'),
				price = parseFloat(_this.selector.find('.gift-price').attr('data-price')),
				gifts = parseInt(_this.selector.find('input.change-num-gift').val()),
				sum = 0,
				cnt = 0;

			$.each(_this.toys, function (i, toy) {
				sum += toy['cnt'] * toy['price'];
				cnt += toy['cnt'];

				_this.selector.find('.toy[data-id="t-' + toy['id'] + '"]').find('.cnt').text(toy['cnt']);
			});

			_this.selector.find('.cnt-toys').text(cnt);
			_this.selector.find('.total-toys').text(sum);

			let total = (price * gifts) + sum;
			total = Math.round((total) * 100) / 100;

			$total.attr('data-total', total).text(total);
		}
	},

	Gift: {
		run: function () {
			let _this = Constructor,
				$selector = _this.selector,
				sweets = [];

			$.each(_this.sweets, function (i, sweet) {
				if (sweet['cnt'] > 0) {
					let c_sweet = {
						id: sweet['id'],
						cnt: sweet['cnt'],
						weight: sweet['weight']
					};
					sweets.push(c_sweet);
				}
			});

			_this.sweets = sweets;

			let data = {
				package: $selector.find('.package-image').data('id'),
				weight: parseInt($('#constructor-panel').find('.package-current-weight').text()),
				sweets: sweets,
				_token: App.csrf
			};

			$.post('/constructor/confirm', data, function (data) {
				let $selector = Constructor.selector,
					$section = $selector.find('.constructor-package-wrapper');

				if (data.error === false) {
					$section.html(data.view);

					$selector.find('.filters-package').slideUp('slow');
					$selector.find('#placeholder-body > div').first().slideUp();
					$selector.find('#placeholder-body > div').last().removeClass().addClass('col-12');

					let $swiper = $selector.find('.swiper');
					if($swiper.length) {
						$swiper.each(function () {
							VGCarousel.init(this);
						});
					}

					_this.Steps.set(3);
					Constructor.Action.top($selector.offset().top);
				}
			});
		},

		change: function ($self, action) {
			let _this = Constructor,
				$counter = $self.closest('.counter'),
				$input = $counter.find('input'),
				cnt = parseInt($input.val()),
				min = parseInt($input.attr('min')),
				max = parseInt($input.attr('max')),
				type = $self.attr('data-type');

			if (!action) {
				if (type === 'minus') {
					if (cnt > min) {
						cnt--;
					} else {
						cnt = min
					}
				}

				if (type === 'plus') {
					if (cnt < max) {
						cnt++;
					} else {
						cnt = max
					}
				}
			}

			if (cnt === min) {
				$self.attr('disabled', true);
			} else {
				$self.closest('.counter').find('[data-type="minus"]').attr('disabled', false);
			}

			if (cnt >= max) {
				$self.attr('disabled', true);
			} else {
				$self.closest('.counter').find('[data-type="plus"]').attr('disabled', false);
			}

			$input.val(cnt);

			_this.Gift.calculation();
		},

		calculation: function () {
			let price = parseFloat(Constructor.selector.find('.gift-price').attr('data-price')),
				cnt = parseInt(Constructor.selector.find('.change-num-gift').val()),
				toy = parseInt(Constructor.selector.find('.total-toys').text());

			let total = (price + toy) * cnt;
			total = Math.round((total) * 100) / 100;

			Constructor.selector.find('.gift-payment').text(total);
		}
	},

	Order: {
		get: function () {
			let _this = Constructor,
				$selector = _this.selector,
				sweets = [];

			$.each(_this.sweets, function (i, sweet) {
				if (sweet['cnt'] > 0) {
					let c_sweet = {
						id: sweet['id'],
						cnt: sweet['cnt'],
						weight: sweet['weight']
					};
					sweets.push(c_sweet);
				}
			});

			_this.sweets = sweets;

			let toys = [];
			$('#swiper-toys .toy.active').each(function (i, e) {
				toys.push({
					id: $(e).data('id'),
					cnt: $(e).find('.cnt-toy-input').val(),
				});
			});

			let params = {
				package_id: $selector.find('.package-image').data('id'),
				weight: parseInt($('#constructor-panel').find('.package-current-weight').text()),
				fitems: sweets,
				toys: toys,
				cnt: $("#num[form=form-confirm]").val(),
				_token: App.csrf
			};

			$.post('/basket/add_product', params, function (data) {
				Basket.showModalAdded('Товар', '');
				Basket.updateGlobalProductsCounter(data.basket_cnt_products);
			});
		}
	}
}

$(document).ready(function () {
	/**
	 * Packages
	 */
	$(document).find('#constructor-sort [data-sort-type]').click(function () {
		Constructor.Package.sort($(this));

		return false;
	});

	$(document).on('click', '.getFiltersPackage', function () {
		Constructor.Package.filter($(this));

		return false;
	});

	$(document).on('click', '.dropFiltersPackage', function () {
		Constructor.Package.reset($(this));

		return false;
	});

	$(document).on('click', '.choice-package', function () {
		Constructor.Package.choice($(this));

		return false;
	});

	$(document).on('click', '.getBack', function () {

		return false;
	});

	/**
	 * Sweets
	 */
	$(document).on('click', '.change-cnt', function () {
		Constructor.Sweets.choice($(this));

		return false;
	});

	$(document).on('change', 'input[name="cnt"]', function () {
		Constructor.Sweets.choice($(this), 'change');

		return false;
	});

	$(document).on('click', '.btn-reload:not(.disabled)', function () {
		Constructor.Action.reset();

		return false;
	});

	$(document).on('click', '.getToTop', function () {
		Constructor.Action.top(Constructor.selector.offset().top);

		return false;
	});

	$(document).on('click', '.sweet-load-more', function () {
		if (!$(this).hasClass('null')) {
			let offset = parseInt($(this).attr('data-offset'));

			Constructor.Sweets.load(offset);

			let total = offset + 50;

			$(this).attr('data-offset', total);
		}

		return false;
	});

	$(document).on('click', '.getFilters', function () {
		Constructor.Sweets.filters($(this));

		return false;
	});

	$(document).on('click', '.dropFilters', function () {
		Constructor.Sweets.reset($(this));

		return false;
	});

	/**
	 * Gift
	 */
	$(document).on('click', '.btn-order:not(.disabled)', function () {
		Constructor.Gift.run();

		return false;
	});

	$(document).on('click', '.cnt-gift', function () {
		Constructor.Gift.change($(this));

		return false;
	});

	/**
	 * Toys
	 */
	$(document).on('click', '.choiceToyConstruct', function () {
		Constructor.Toys.add($(this));

		return false;
	});

	$(document).on('click', '.cnt-toy', function () {
		Constructor.Toys.change($(this));

		return false;
	});

	$(document).on('change', 'input.cnt-toy-input', function () {
		Constructor.Toys.change($(this));

		return false;
	});

	/**
	 * Order
	 */
	$(document).on('click', '.btn-get-confirm-cart', function () {
		Constructor.Order.get();
		return false;
	});

	$(document).on('click', '.btn-constructor-pdf', function () {
		let $container = $('#constructor');

		var newForm = jQuery('<form>', {
				'action': $(this).attr('href'),
				'target': '_blank',
				'method': 'post',
			}).append(jQuery('<input>', {
				'name': 'data',
				'value': JSON.stringify([
						{
							name: 'package',
							value: $container.find('.package-image').data('id')
						},
						{
							name: 'num',
							value: $container.find('[name=num]').val()
						}
					]
				),
				'type': 'hidden'
			})).append(jQuery('<input>', {
				'name': 'sweets',
				'value': JSON.stringify(Constructor.sweets),
				'type': 'hidden'
			})).append(jQuery('<input>', {
				'name': 'toys',
				'value': JSON.stringify(Constructor.toys),
				'type': 'hidden'
			})).append(jQuery('<input>', {
				'name': '_token',
				'value': App.csrf,
				'type': 'hidden'
			}))
		;
		newForm.appendTo('body').submit();

		return false;
	});
});
